/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Options_Cli_Select_Executable_HelpInputs */

const en_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select the location of the ${i?.tool} executable`)
};

const fr_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sélectionner l'emplacement de l'exécutable ${i?.tool}`)
};

const de_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wählen Sie den Speicherort der ausführbaren Datei ${i?.tool} aus.`)
};

const it_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleziona la posizione dell'eseguibile ${i?.tool}`)
};

const ru_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выберите местоположение исполняемого файла ${i?.tool}`)
};

const es_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccione la ubicación del ejecutable ${i?.tool}`)
};

const zh_cn2_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`选择 ${i?.tool} 可执行文件的位置`)
};

const ja_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tool} 実行ファイルの場所を選択します`)
};

const hi_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tool} निष्पादन योग्य फ़ाइल का स्थान चुनें`)
};

const pt_pt2_options_cli_select_executable_help = /** @type {(inputs: Options_Cli_Select_Executable_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecione a localização do executável ${i?.tool}`)
};

/**
* | output |
* | --- |
* | "Select the location of the {tool} executable" |
*
* @param {Options_Cli_Select_Executable_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_executable_help = /** @type {((inputs: Options_Cli_Select_Executable_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_Executable_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_select_executable_help(inputs)
	if (locale === "de") return de_options_cli_select_executable_help(inputs)
	if (locale === "it") return it_options_cli_select_executable_help(inputs)
	if (locale === "ru") return ru_options_cli_select_executable_help(inputs)
	if (locale === "es") return es_options_cli_select_executable_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_select_executable_help(inputs)
	if (locale === "ja") return ja_options_cli_select_executable_help(inputs)
	if (locale === "hi") return hi_options_cli_select_executable_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_select_executable_help(inputs)
	return en_options_cli_select_executable_help(inputs)
});